import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ChipField,
  SelectField,
  ReferenceField,
  Filter,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  TextInput
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeService } from "../../constant/TypeService";
import Actions from '../Actions'

const ServiceFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="name_contains" />
      <SelectInput source="type" choices={typeService} />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const ServiceList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="service.service"
      bulkActions={false}
      actions={<Actions create />}
      filters={<ServiceFilter />}
      filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <SelectField
          source="type"
          optionText={<ChipField source="name" />}
          choices={typeService}
        />
        <ReferenceField source="project" reference="project" linkType={false}>
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/service/ServiceList.js